import { render, staticRenderFns } from "./PrescriptionList.vue?vue&type=template&id=27697134"
import script from "./PrescriptionList.vue?vue&type=script&lang=js"
export * from "./PrescriptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports